import {
    InvoiceStatus,
    DealStatus,
    InvoiceTableRowStatus,
    Approval,
    Bill,
    Deal,
} from '@lendica/utils';

export const enum RowType {
    Bill = 'bill',
    Deal = 'deal',
}

export interface BillOrDealRow {
    id: string;
    invoice_number: string;
    funded_date?: string;
    vendor_name: string;
    amount?: number;
    paid?: number;
    type: RowType;
    status: InvoiceStatus | DealStatus;
}

export enum ActionType {
    Schedule = 'schedule',
    Edit = 'edit',
    View = 'view',
    Archive = 'archive',
}
export interface BillTableRow {
    id: string;
    type: RowType;
    vendor: string;
    status: InvoiceTableRowStatus;
    invoice_number: string;
    invoice_date: string;
    amount: string | number;
    due_date: string;
    funding_date: string;
}

export interface PayLaterDataProps {
    approval: Approval | undefined;
    bills: Bill[] | undefined;
    deals: Deal[] | undefined;
}

export const NULL_VALUE_FALLBACK = `\u2014`;
